import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaEventService } from '../../../services/ga-event.service';
import * as _ from 'underscore';
import { IDialogButton } from '../../../message/ga-message.service';
import { BUTTON_SAVE } from '../../../message/dialogs/default-form-dialog.component';
import { IUploadFile, IUploadFileCompleteEvent } from '../../../multi-file-upload/multi-file-upload.component';

@Component({
  selector: 'add-images-action',
  template: `
    <default-dialog [title]="title" [buttons]="buttons" [closeButton]="true" (onClose)="cancelUpload()">
      <multi-file-upload
        [path]="postUrl"
        [uploading]="uploading"
        [showButtons]="false"
        (onQueueChange)="onFileChange($event)"
        (onUploadCompleted)="onUploadCompleted($event)"
        (onUploadCancelled)="onUploadCancelled()"
        (onUploadError)="onUploadError()"
        [filesAccepted]="['image/*']">
      </multi-file-upload>
    </default-dialog>
  `
})
export class AddImagesActionComponent extends BaseReportActionsDialog implements OnInit {
  public postUrl:string = '/ga2/rest/globalproduct/products/image';
  public uploading:boolean;
  public filesToUpload:number = 0;
  public buttons:IDialogButton[];

  constructor(
    eventService:GaEventService,
    validateService:GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit():void {
    this.buttons = [
      {
        id: BUTTON_SAVE,
        label: this.title,
        className: 'btn btn-success',
        onClick: this.startUpload,
        busy: this.uploading,
        disabled: !this.filesToUpload
      },
      {
        label: 'GA.BUTTONS.CANCEL',
        className: 'btn btn-danger',
        onClick: this.cancelUpload
      }
    ];
  }

  // triggered by multi-file-upload component when are changes in the list of selected files
  public onFileChange(files:IUploadFile[]):void {
    this.filesToUpload = files?.length;
    this.updateButtonStatus();
  }

  public startUpload = ():void => {
    this.uploading = true;
    this.updateButtonStatus();
  };

  // triggered by multi-file-upload component after the files are uploaded
  public onUploadCompleted(event:IUploadFileCompleteEvent):void {
    if (event.success) {
      this.model.images = this.getImageKeys(event.files);
      this.execute();
    } else {
      this.uploading = false;
    }
  }

  public cancelUpload = ():void => {
    this.uploading = false;
    this.updateButtonStatus();
    this.onCancel.emit();
  };

  // triggered by multi-file-upload component
  public onUploadCancelled():void {
    this.uploading = undefined;
    this.updateButtonStatus();
  }

  public onUploadError():void {
    this.uploading = false;
    this.updateButtonStatus();
  }

  private getImageKeys(files:IUploadFile[]):number[] {
    const imageKeys:number[] = [];
    _.each(files, (file:IUploadFile) => {
      if (file?.response?.data) {
        imageKeys.push(file.response.data.id);
      }
    });
    return imageKeys;
  }

  protected updateButtonStatus():void {
    const button:IDialogButton = _.find(this.buttons, { id: BUTTON_SAVE });
    if (button) {
      button.busy = this.uploading;
      button.disabled = !this.filesToUpload;
    }
  }
}